import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { ChevronCircleLeftSolidIcon } from '@compono/ui-icons';
import { useTheme } from '../hooks/useTheme.js';
import { IconButton } from '../IconButton/IconButton.js';
import 'react';
import '../Box/index.js';
import { useLayoutScreenContext } from '../LayoutScreen/LayoutScreen/LayoutScreenContext.js';
import '../LayoutScreen/LayoutHeader/LayoutHeader.js';
import { useMainNavContext } from './MainNavContext/index.js';

var MainNavToggle = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "Expand or collapse the menu" : _b, sx = _a.sx, props = __rest(_a, ["label", "sx"]);
    var sidebar = useLayoutScreenContext({ optional: true }).sidebar;
    var themeKey = useMainNavContext().themeKey;
    var handleStyleProps = useTheme().handleStyleProps;
    if (!sidebar)
        return null;
    var setPreference = sidebar.collapseState.setPreference;
    var forwardProps = handleStyleProps({ sx: sx }, { themeKey: "".concat(themeKey, "Toggle") });
    return (jsx(IconButton, __assign({ "data-nav-toggle": true, rounded: true, look: "naked", tone: "inherit", label: label, onClick: function () { return setPreference("toggle"); }, sx: { "--button-size": "16px", "--icon-size": "16px" } }, props, forwardProps, { children: jsx(ChevronCircleLeftSolidIcon, {}) })));
};

export { MainNavToggle };
//# sourceMappingURL=MainNavToggle.js.map
